// Libarary
import { Injectable } from '@angular/core';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';

@Injectable()
export class CppUserListService {
  public redirectFrom: any;

  constructor(public configService: ConfigService, public networkService: NetworkService) { }
  editDeliveryAccountNo: any;
  // Get Delivery Instructions List
  public getcppUserList(dashboardFilter) {
    return this.networkService.postRequest(this.configService.getcppUserListUrl(), dashboardFilter);
  }

  // Get Delivery Instructions List
  public getDeliveryInstructionAccountList() {
    return this.networkService.getRequest(this.configService.getCPPUserListAccountsList());
  }
  // saveUserList
  public saveUserList(payload) {
    return this.networkService.postRequest(this.configService.getCPPUserListEditData(), payload);
  }
  // get view/edit data
  public getcppUser(accountNumber) {
    return this.networkService.getRequest(this.configService.getcppUser() + '?accountNumber=' + accountNumber);
  }

  public deleteUserList(payload) {
    return this.networkService.postRequest(this.configService.getCPPUserListDeleteData(), payload);
  }
}
